import SeedType from '../enums/SeedType';

export default function seedType(input: string): string {

    switch(input) {

        case SeedType.SEED: return 'Zaad';
        case SeedType.HALF_GROWN: return 'Halfwas';
        case SeedType.CONSUMPTION: return 'Consumptie';
        default: return '-';
    }
}
